document.addEventListener('DOMContentLoaded', () => {

    document.querySelector('.l-mobile-header__top__left__menu-toggle').addEventListener('click', function () {
        this.classList.toggle('is-active')
        document.querySelector('.l-mobile-header').classList.toggle('l-mobile-header--open')

        if (!document.querySelector('.l-mobile-header').classList.contains('l-mobile-header--open')) {
            document.querySelectorAll('.c-mobile-nav__item').forEach(function (el) {
                el.classList.remove('c-mobile-nav__item--open')
            })

            document.querySelectorAll('.c-mobile-nav__item__list').forEach(function (el) {
                el.classList.remove('c-mobile-nav__item__list--open')
            })
        }
    })

    document.querySelectorAll('.js-mobile-nav-list-btn').forEach(function(btn) {
        btn.addEventListener('click', function () {

            const targetId = btn.getAttribute('data-id')
            const menuList = document.querySelector('.c-mobile-nav__item__list[data-id='+ targetId + ']')
            const navItem = document.querySelector('.c-mobile-nav__item[data-id=' + targetId + ']')

            if (!navItem.classList.contains('c-mobile-nav__item--open')) {
                navItem.classList.add('c-mobile-nav__item--open')
                menuList.classList.add('c-mobile-nav__item__list--open')
                return
            }

            if (navItem.classList.contains('c-mobile-nav__item--open')) {
                navItem.classList.remove('c-mobile-nav__item--open')
                menuList.classList.remove('c-mobile-nav__item__list--open')
            }
        });
    })

    const header = document.querySelector('.l-header')
    const mobileHeader = document.querySelector('.l-mobile-header')

    setHeaderScrollClass(header, mobileHeader)
    window.addEventListener('scroll', function () {
        resetMenuListState()
        setHeaderScrollClass(header, mobileHeader)
    })

    function setHeaderScrollClass(header, mobileHeader) {
        if (window.scrollY > 0) {
            header.classList.add('l-header--scroll')
            mobileHeader.classList.add('l-mobile-header--scroll')
        }

        if (window.scrollY === 0) {
            header.classList.remove('l-header--scroll')
            mobileHeader.classList.remove('l-mobile-header--scroll')
        }
    }
    function resetMenuListState() {
        document.querySelectorAll('.c-main-nav__item').forEach(function (item) {
            item.classList.remove('c-main-nav__item--open')
        })
        document.querySelectorAll('.c-main-nav__item__list').forEach(function (item) {
            item.classList.remove('c-main-nav__item__list--open')
        })
    }

    document.querySelectorAll('.js-search-btn').forEach(function (searchBtn) {
        searchBtn.addEventListener('click', function (e) {
            const searchModal = document.querySelector('.l-modal-screen--search')
            const headerLayout = document.querySelector('.l-header')
            const headerLayoutMobile = document.querySelector('.l-mobile-header')
            const documentBody = document.body

            searchModal.classList.add('open')
            headerLayout.classList.add('l-header--scroll')
            headerLayoutMobile.classList.add('l-mobile-header--scroll')
            documentBody.classList.add('no-scroll')

            document.querySelector('.js-search-form').focus();
        })
    })

    document.querySelectorAll('.js-close-search-btn').forEach(function (closeSearchBtn) {
        closeSearchBtn.addEventListener('click', function (e) {
            const searchModal = document.querySelector('.l-modal-screen--search')
            const headerLayout = document.querySelector('.l-header')
            const headerLayoutMobile = document.querySelector('.l-mobile-header')
            const documentBody = document.body

            searchModal.classList.remove('open')
            documentBody.classList.remove('no-scroll')

            if (window.scrollY === 0) {
                headerLayout.classList.remove('l-header--scroll')
                headerLayoutMobile.classList.remove('l-mobile-header--scroll')
            }
        })
    })

    document.querySelectorAll('.has-submenu').forEach(item => {
        item.addEventListener('click', e => {
            e.preventDefault();
            const submenuId = e.target.dataset.submenu;
            const parentMenu = e.target.dataset.parent;

            if (parentMenu === 'main') {
                document.querySelector('ul.menu-main').style.display = 'none';
            } else {
                document.querySelector(`ul[data-parent="${parentMenu}"]`).style.display = 'none';
            }

            document.querySelector(`ul[data-parent="${submenuId}"]`).style.display = 'block';
        });
    });

    document.querySelectorAll('.parent-link a, .parent-back').forEach(item => {
        item.addEventListener('click', e => {
            e.preventDefault();
            const parentId = e.target.dataset.parent;
            e.target.closest('ul').style.display = 'none';

            if (parentId === '0') {
                document.querySelector('ul.menu-main').style.display = 'block';
            } else {
                const parentMenu = document.querySelector(`a[data-submenu="${parentId}"]`);
                (parentMenu?.closest('ul') || document.querySelector('ul.menu-main')).style.display = 'block';
            }
        });
    });

})
